<template>
  <div>
    <div v-if="hasAccess">
      <slot></slot>
    </div>
    <div v-if="!hasAccess && isPage && !$apollo.loading">
      <empty>
        <p>You don't have permission to access this resource.</p>
        <p class="description">Please contact your administrator if you feel this is in error.</p>
      </empty>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag';
import { mapState } from 'vuex';

import Empty from '@/components/common/Empty';

export default {
  name: 'Can',
  components: {
    Empty,
  },
  props: {
    action: {
      type: String,
      required: true,
    },
    subject: {
      type: String,
      required: true,
    },
    module: {
      type: String,
    },
    region: {
      type: String,
    },
    isPage: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    permissions: [],
  }),
  apollo: {
    $client: 'apiv2',
    myAccess: {
      query: gql`
        {
          myAccess {
            permission {
              id
              action
              subject
            }
            organization
            company
            global
          }
        }
      `,
    },
  },
  computed: {
    ...mapState('user', ['me']),

    hasAccess() {
      const hasActionAndSubject = p => p.action === this.action && p.subject === this.subject;
      const hasOrgAccess = p => p.organization;
      const hasCompAccess = p => p.company && this.me.company === this.me.use_as_company;
      const hasGlobalAccess = p => p.global;
      const hasPermissionAccess = p => hasOrgAccess(p) || hasCompAccess(p) || hasGlobalAccess(p);

      const hasModuleAccess = () => true;
      const hasRegionAccess = () => true;
      const hasLayerAccess = p => hasModuleAccess(p) && hasRegionAccess(p);

      return (
        this.permissions.findIndex(
          p =>
            (hasActionAndSubject(p) && hasPermissionAccess(p) && hasLayerAccess(p)) ||
            (hasActionAndSubject(p) && hasGlobalAccess(p) && hasLayerAccess(p)),
        ) !== -1
      );
    },
  },
  watch: {
    myAccess() {
      this.permissions = this.myAccess.map(a => ({
        action: a.permission.action,
        subject: a.permission.subject,
        organization: a.organization,
        company: a.company,
        global: a.global,
      }));
    },
  },
};
</script>

<style>
.can {
  border: 1px solid #c0c0c0;
}
.access-true {
  border: 1px solid #0f0;
}
.access-false {
  border: 1px solid #f00;
}
.description {
  font-size: 0.7em;
}
</style>



// WEBPACK FOOTER //
// Can.vue?6c2ab7be